import { EmptyState } from "@estate-platform/ui/empty-state";

import type { LucideIcon } from "lucide-react";
import type { ReactElement, ReactNode } from "react";

export interface StatusPageProps {
  readonly icon: LucideIcon;
  readonly title: string;
  readonly hint: string;
  readonly action?: ReactNode;
}

export const StatusPage = ({ icon, title, hint, action }: StatusPageProps): ReactElement => (
  <div className="flex h-full flex-col overflow-y-auto bg-ground p-6 text-ink">
    <div className="m-auto">
      <EmptyState icon={icon} title={title} hint={hint} action={action} />
    </div>
  </div>
);
